<template>
  <ul
    :aria-label="tc('spaSoft.step1.treatmentCards.ariaLabelAvailableTreatments', { categoryTitle: selectedCategory })"
    class="treatments-list"
  >
    <li
      v-for="(item, index) in items"
      :key="item.Id"
      class="treatments-list__item"
    >
      <TreatmentsCard
        :treatment="item"
        :index="index"
        @treatment-selected="$emit('treatment-selected')"
      />
    </li>
  </ul>
</template>

<script>
  import { mapGetters } from 'vuex'
  import TreatmentsCard from './treatments-card.vue'

  export default {
    name: 'TreatmentsList',
    components: {
      TreatmentsCard
    },

    props: {
      items: {
        type: Array,
        required: true,
        default: () => ([])
      },
      selectedCategory: {
        type: String,
        required: true
      },
    },

    data() {
      return {}
    },
    computed: {
      ...mapGetters('i18n', ['tc']),
    },
    mounted() {},
    methods: {}
  }
</script>
